// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7730":"dbdb3ba4b9f542b0","9838":"668d1783a9d3769e"}[chunkId] + ".js";
};